module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO35PresupuestoMensual.acccac1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO35PresupuestoMensual.mp4
// module id = 761
// module chunks = 1